// ─────────────────────────────────────────────────────────────────────────────
// Salesforce Events — Public API
// Importar sempre via: import { SalesforceEventsService } from '@app/core/salesforce';
// ─────────────────────────────────────────────────────────────────────────────

export { SalesforceEventsService } from "./salesforce-events.service";
export type {
  SalesforceEventMap,
  SalesforceEventName,
  SfCommonParams,
  SfBuscaFiltroParams,
  SfBuscaParams,
  SfAdicionarCarrinhoParams,
  SfRemoverCarrinhoParams,
  SfPagamentoParams,
  SfCompraParams,
  SfCarrinhoParams,
  SfPageViewParams,
  SfPageViewNomePagina,
  SfCadastroParams,
  SfCadastroEmpresaParams,
} from "./salesforce-events.types";
export {
  SF_PAGE_VIEW_NAMES,
  SF_PAGE_VIEW_PENDING_ROUTES,
  buildSfAdicionarCarrinhoParams,
  buildSfBuscaFiltroParams,
  buildSfCarrinhoParams,
  buildSfCadastroParams,
  buildSfCadastroEmpresaParams,
  buildSfRemoverCarrinhoParams,
  resolveProductMarca,
  resolveProductValor,
  routeToSfPageViewNome,
  resetSfPageViewDedupForTests,
} from "./salesforce-events.mappers";
export { SALESFORCE_EVENT_SCHEMA } from "./salesforce-events.schema";
export type { SalesforceAttributeSchema, SalesforceAttributeType } from "./salesforce-events.schema";
export type {
  SfCadastroEmpresaContext,
  SfCatalogFilterContext,
  SfCartProductContext,
} from "./salesforce-events.mappers";
